/*=========================================================================================
  File Name: moduleUserManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleInvestorManagementState.js'
import mutations from './moduleInvestorManagementMutations.js'
import actions from './moduleInvestorManagementActions.js'
import getters from './moduleInvestorManagementGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

